// In-memory cache for public catalog data. Avoids re-fetching heavy vehicle lists
// when navigating back from a vehicle detail page. TTL: 2 minutes.
const TTL_MS = 2 * 60 * 1000;
const store = new Map(); // key -> { data, ts }

export function getCached(key) {
  const hit = store.get(key);
  if (!hit) return null;
  if (Date.now() - hit.ts > TTL_MS) {
    store.delete(key);
    return null;
  }
  return hit.data;
}

export function setCached(key, data) {
  store.set(key, { data, ts: Date.now() });
}

export function invalidateCache(prefix = "") {
  if (!prefix) { store.clear(); return; }
  for (const k of Array.from(store.keys())) {
    if (k.startsWith(prefix)) store.delete(k);
  }
}
